// Generated by CoffeeScript 2.7.0
var PaginatedResources;

import Ajax from './ajax.js';

export default PaginatedResources = class PaginatedResources {
  constructor(url, options) {
    this.url = url;
    this.callback = options.callback;
    this.completedCallback = options.completedCallback;
    this.params = options.params;
    this.nextPage = 1;
    this.doRequest();
  }

  doRequest() {
    return Ajax.get(this.url, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'json',
      data: this._composeParams(),
      success: (data, xhr) => {
        var total_pages;
        if (typeof this.callback === "function") {
          this.callback(data);
        }
        this.nextPage = (parseInt(xhr.getResponseHeader('X-SLP-Current-Page')) || 1) + 1;
        total_pages = parseInt(xhr.getResponseHeader('X-SLP-Total-Pages')) || 0;
        if ((this.nextPage - 1) < total_pages) {
          return this.doRequest();
        } else {
          return typeof this.completedCallback === "function" ? this.completedCallback() : void 0;
        }
      }
    });
  }

  _composeParams() {
    return _.extend({}, this.params, {
      page: this.nextPage
    });
  }

};
